import { DataGrid } from "../../../../components/data-grid";
import { testColumns } from "../../../../components/tests-table";
import type { Test } from "../../../../types";

interface VariantsTabProps {
  variants: Test[] | undefined;
  isLoading: boolean;
}

export function VariantsTab({ variants, isLoading }: VariantsTabProps) {
  return <DataGrid loading={isLoading} rows={variants ?? []} columns={testColumns} />;
}
